<div class="prepare-container">
  <div class="left-panel">
    <h1>{{ data.scenario.title }}</h1>
    <h2>
      {{ data.scenario.role_user.job_title }} -
      {{ data.scenario.role_user.job_title }}
    </h2>

    <p>
      {{ data.scenario.context }}
    </p>

    <ul *ngFor="let item of data.scenario.challenges">
      <li>{{ item }}</li>
    </ul>

    <p>{{ data.scenario.mission }}</p>

    <p>{{ data.scenario.final_message }}</p>

    <div class="button-container">
      <button class="btn" (click)="startTest()">Start test</button>
    </div>
  </div>

  <div class="right-panel">
    <!-- ORGANIZATION CHART -->
    <div class="organization-chart">
      <h1 class="mediumTitle">Organization chart</h1>
      <div class="chart-conatiner">
        <div [style.transform]="'scale(' + zoom + ')'" style="display: flex">
          <ngx-org-chart [nodes]="nodes" direction="vertical"></ngx-org-chart>
        </div>
      </div>
      <div class="zoom-button-container">
        <button class="btn" (click)="zoomOrganizationChart(-0.1)">-</button>
        <button class="btn" (click)="zoomOrganizationChart(+0.1)">+</button>
      </div>
    </div>

    <br />

    <!-- ADOPTION STAGE OF THE ORGANIZATION -->
    <div class="adoption-stage">
      <h1 class="mediumTitle">Adoption stage of the organization</h1>
      <div class="stepper-wrapper">
        <div class="stepper-item" [ngClass]="{ completed: stepperStatus[0] }">
          <div class="step-counter">1</div>
          <div class="step-name">Mobilization</div>
        </div>
        <div class="stepper-item" [ngClass]="{ completed: stepperStatus[1] }">
          <div class="step-counter">2</div>
          <div class="step-name">Movement</div>
        </div>
        <div class="stepper-item" [ngClass]="{ completed: stepperStatus[2] }">
          <div class="step-counter">3</div>
          <div class="step-name">Support</div>
        </div>
      </div>
    </div>
  </div>
</div>
